import React, { useState, useEffect } from "react";
import {
  Box,
  Grid,
  TextField,
  Card,
  CardContent,
  Typography,
  Button,
  CircularProgress,
  InputAdornment,
  // MenuItem,
  // FormControl,
  // InputLabel,
  // Select,
  // Stack,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import AddIcon from "@mui/icons-material/Add";
import SearchIcon from "@mui/icons-material/Search";
import * as customerServices from "../../services/customer";
import * as salengServices from "../../services/saleng";
import AppBreadcrumbs from "../../components/AppBreadcrumbs";
import CarSelectDialog from "../../components/CarSelectDialog";

const { v4: uuidv4 } = require("uuid");

function UserList() {
  const [search, setSearch] = useState("");
  const [carType] = useState("");
  const [licenseFilter] = useState("");
  const [provinceFilter] = useState("");

  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(true);

  const [selectedCustomer, setSelectedCustomer] = useState([]);
  const [openCarSelectDialog, setOpenCarSelectDialog] = useState(false);

  const navigate = useNavigate();

  const fetchCustomers = async () => {
    try {
      setLoading(true);
      const response = await customerServices.getCustomers();
      const data = response.data.data;
      setCustomers(data);
      return data;
    } catch (error) {
      console.error("Error fetching customers:", error);
      return [];
    } finally {
      setLoading(false);
    }
  };

  const handleCustomerPicked = async (data) => {
    const customer = data.customer;
    const car = data.car;
    const driver = data.driver;

    const payload = {
      transactionId: uuidv4(),
      customerId: customer.id,
      carId: car?.id,
      driverId: driver?.id,
      customerName: customer.name,
      status: "waiting",
    };
    const response = await salengServices.createTransaction(payload);
    navigate(
      `/buy/checkout?id=${response.data.data.transactionId}&ticket=${response.data.data.billNumber}`
    );
  };

  useEffect(() => {
    fetchCustomers();
  }, []);

  // ฟังก์ชันช่วยเช็กการ match ตาม filter
  const includesSafe = (a = "", b = "") =>
    String(a).toLowerCase().includes(String(b).toLowerCase());

  const matchCarType = (customer) => {
    if (!carType) return true;
    return (customer.cars || []).some((car) => car?.type === carType);
  };

  const matchLicense = (customer) => {
    if (!licenseFilter) return true;
    return (customer.cars || []).some((car) =>
      includesSafe(car?.license, licenseFilter)
    );
  };

  const matchProvince = (customer) => {
    if (!provinceFilter) return true;
    return (customer.cars || []).some((car) =>
      includesSafe(car?.province, provinceFilter)
    );
  };

  // 🔎 ค้นหาทั้ง "ชื่อซัพพลายเออร์" และ "ทะเบียนรถ"
  const matchSearch = (customer) => {
    if (!search) return true;
    const byName = includesSafe(customer.name, search);
    const byCarLicense = (customer.cars || []).some((car) =>
      includesSafe(car?.license, search)
    );
    return byName || byCarLicense;
  };

  const filteredData = customers.filter(
    (item) =>
      matchSearch(item) &&
      matchCarType(item) &&
      matchLicense(item) &&
      matchProvince(item)
  );

  const handleCardClick = async (customerId) => {
    const customer = filteredData.find((item) => item.id === customerId);
    if (!customer) return;

    if (customer.cars?.length === 0) {
      const payload = {
        transactionId: uuidv4(),
        customerId: customer.id,
        customerName: customer.name,
        status: "waiting",
      };
      const response = await salengServices.createTransaction(payload);
      navigate(
        `/buy/checkout?id=${response.data.data.transactionId}&ticket=${response.data.data.billNumber}`
      );
    } else {
      setSelectedCustomer(customer);
      setOpenCarSelectDialog(true);
    }
  };

  const handleCreateClick = () => {
    navigate(`/customers/create?buy=true`);
  };

  return (
    <>
      <Box sx={{ p: 2 }}>
        <AppBreadcrumbs />

        {/* 🔍 ค้นหา + ปุ่มสร้าง */}
        <Box
          sx={{
            my: 2,
            display: "flex",
            flexWrap: "wrap",
            gap: 2,
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          {/* ฝั่งซ้าย: ค้นหา (ฟิลเตอร์อื่นๆ เก็บไว้ด้านล่างเป็นคอมเมนต์) */}
          <Box
            sx={{
              display: "flex",
              gap: 2,
              flexWrap: "wrap",
              alignItems: "center",
            }}
          >
            <TextField
              fullWidth
              label="ค้นหา"
              placeholder="ค้นหาชื่อ หรือ ทะเบียนรถ"
              variant="outlined"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              sx={{ mb: 2, mt: 2, width: 500 }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon color="action" />
                  </InputAdornment>
                ),
              }}
            />

            {/*
          // สร้างรายการประเภทรถจากข้อมูลจริง (unique)
          // const carTypeOptions = useMemo(() => {
          //   const set = new Set();
          //   customers.forEach((c) =>
          //     (c.cars || []).forEach((car) => {
          //       if (car?.type) set.add(car.type);
          //     })
          //   );
          //   return Array.from(set);
          // }, [customers]);

          // ฟิลเตอร์ประเภทรถ
          // <FormControl sx={{ minWidth: 200 }}>
          //   <InputLabel id="car-type-label">ประเภทรถ</InputLabel>
          //   <Select
          //     labelId="car-type-label"
          //     value={carType}
          //     label="ประเภทรถ"
          //     onChange={(e) => setCarType(e.target.value)}
          //   >
          //     <MenuItem value="">ทั้งหมด</MenuItem>
          //     {carTypeOptions.map((t) => (
          //       <MenuItem key={t} value={t}>
          //         {t}
          //       </MenuItem>
          //     ))}
          //   </Select>
          // </FormControl>

          // ฟิลเตอร์เลขทะเบียน
          // <TextField
          //   label="เลขทะเบียน (กรอง)"
          //   variant="outlined"
          //   value={licenseFilter}
          //   onChange={(e) => setLicenseFilter(e.target.value)}
          //   placeholder="เช่น 1234"
          //   sx={{ width: 200 }}
          // />

          // ฟิลเตอร์จังหวัด
          // <TextField
          //   label="จังหวัด (กรอง)"
          //   variant="outlined"
          //   value={provinceFilter}
          //   onChange={(e) => setProvinceFilter(e.target.value)}
          //   placeholder="เช่น กรุงเทพมหานคร"
          //   sx={{ width: 200 }}
          // />
          // ==============================================================
          */}
          </Box>

          {/* ฝั่งขวา: ปุ่ม */}
          <Button
            variant="contained"
            color="primary"
            startIcon={<AddIcon />}
            onClick={handleCreateClick}
            sx={{ whiteSpace: "nowrap" }}
          >
            ซัพพลายเออร์ใหม่
          </Button>
        </Box>

        <Card sx={{ p: 2 }}>
          {loading ? (
            <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
              <CircularProgress />
            </Box>
          ) : (
            <Grid container spacing={2} alignItems="stretch">
              {filteredData.map((item) => (
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={4}
                  lg={3}
                  key={item.id}
                  sx={{ display: "flex" }}
                >
                  <Card
                    variant="outlined"
                    onClick={() => handleCardClick(item.id)}
                    sx={{
                      cursor: "pointer",
                      height: "100%",
                      width: "100%",
                      display: "flex",
                      flexDirection: "column",
                      borderRadius: 3,
                      borderColor: "divider",
                      transition: "transform 120ms ease, box-shadow 120ms ease",
                      "&:hover": {
                        transform: "translateY(-2px)",
                        boxShadow: 6,
                      },
                    }}
                  >
                    {/* (ลบแถบฟ้าออกแล้ว) */}
                    <CardContent
                      sx={{
                        flexGrow: 1,
                        display: "flex",
                        flexDirection: "column",
                        gap: 0.5,
                      }}
                    >
                      <Typography fontWeight="bold" noWrap>
                        {item.name}
                      </Typography>
                      <Typography color="text.secondary">
                        {item.personType === "normal"
                          ? "บุคคลธรรมดา"
                          : "นิติบุคคล"}
                      </Typography>

                      {Array.isArray(item.cars) && item.cars.length > 0 && (
                        <Box
                          sx={{
                            mt: 1,
                            p: 1,
                            borderRadius: 1.5,
                            bgcolor: "action.hover",
                          }}
                        >
                          <Typography fontWeight="bold">
                            รถที่ลงทะเบียนไว้
                          </Typography>
                          <Box
                            sx={{
                              maxHeight: 96,
                              overflow: "auto",
                              scrollbarWidth: "none", // Firefox
                              msOverflowStyle: "none", // IE/Edge legacy
                              "&::-webkit-scrollbar": {
                                // Chrome/Safari
                                display: "none",
                              },
                            }}
                          >
                            {item.cars.map((car, idx) => (
                              <Typography key={idx} color="text.secondary">
                                {car?.type ? `${car.type} - ` : ""}
                                {car?.license || "-"}
                                {car?.province ? ` (${car.province})` : ""}
                              </Typography>
                            ))}
                          </Box>
                        </Box>
                      )}
                    </CardContent>
                  </Card>
                </Grid>
              ))}
            </Grid>
          )}
        </Card>
      </Box>

      <CarSelectDialog
        open={openCarSelectDialog}
        onClose={() => setOpenCarSelectDialog(false)}
        customerData={selectedCustomer}
        fetchData={fetchCustomers}
        onSuccess={handleCustomerPicked}
      />
    </>
  );
}

export default UserList;
